var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('p',{staticClass:"offer-comment"},[_vm._v("Komentarz: "+_vm._s(_vm.comment))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }